<script lang="ts">
	import MobileStep from "@components/data-display/MobileStep.svelte";
	import Button from "@components/inputs/Button.svelte";
	import ArrowBackwardIos from "@svg/ArrowBackwardIOS.svelte";
	import ArrowForwardIos from "@svg/ArrowForwardIOS.svelte";

	export let conditions;
	export let requirements;
	export let accent1 = "";
	export let textColor = {
		title: "",
		subtitle: ""
	};
	export let workConditionsTitle = "";
	export let requirementsTitle = "";

	let ref: HTMLElement;
	let activeIndex = 0;

	function observer(node: HTMLElement, index: number) {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					activeIndex = index;
				}
			},
			{
				threshold: 0.5
			}
		);

		observer.observe(node);
	}
</script>

<div
	class="mx-8 mb-2 flex w-full max-w-screen-lg justify-center gap-2 transition-all md:mx-0"
>
	<button
		on:click={() => {
			ref.scrollTo({
				left: -1000,

				behavior: "smooth"
			});
		}}
		class="
		 flex w-full flex-shrink-0 basis-1/2 items-end justify-center border-b-2
					 border-transparent p-2 text-end font-[900]
transition-all sm:text-2xl
			{activeIndex === 0
			? `!border-${accent1} ${textColor.title} text-shadow`
			: 'text-gray-300'}
		"
	>
		{workConditionsTitle}
	</button>
	<button
		on:click={() => {
			ref.scrollTo({
				left: 1000,

				behavior: "smooth"
			});
		}}
		class="
			 flex w-full flex-shrink-0 basis-1/2 items-end justify-center border-b-2
					 border-transparent p-2 text-end font-[900]
 transition-all sm:text-2xl
			{activeIndex === 1
			? `!border-${accent1} ${textColor.title}  text-shadow`
			: 'text-gray-300'}
		"
	>
		{requirementsTitle}
	</button>
</div>
<div
	bind:this={ref}
	class="no-scrollbar my-2 flex w-screen snap-x snap-mandatory overflow-auto md:max-w-screen-md"
>
	<div
		class="flex h-auto w-full flex-shrink-0 snap-center flex-col items-center gap-3"
	>
		<div
			class="
		mb-4 text-3xl font-[900] {textColor.title}
 text-shadow sm:text-5xl
		
		"
		>
			{workConditionsTitle}
		</div>
		<div
			use:observer={0}
			class="flex flex-wrap items-start justify-start gap-4 px-6 pb-2 text-start md:items-center md:justify-center"
		>
			{#each conditions as condition}
				<div
					class={`animate-grow shadow-custom relative flex flex-grow items-center gap-2 overflow-hidden rounded-lg bg-white p-2 shadow-${accent1} md:flex-grow-0`}
				>
					<div class=" text-start text-xs text-black">{@html condition}</div>
				</div>
			{/each}
		</div>
		<Button
			textColor="text-white"
			shadow
			onclick={() => {
				activeIndex = 1;
				ref.scrollTo({
					left: 1000,

					behavior: "smooth"
				});
			}}
			css="my-4"
			color="text-{accent1}"
		>
			<span> {requirementsTitle}</span>
			<ArrowForwardIos slot="icon-end" class="ml-1.5 size-5 fill-current" />
		</Button>
	</div>
	<div
		class="flex h-auto w-full flex-shrink-0 snap-center flex-col items-center gap-3"
	>
		<div
			class="
		mb-4
 text-3xl font-[900] {textColor.title}

 text-shadow sm:text-5xl
		
		"
		>
			{requirementsTitle}
		</div>
		<div
			use:observer={1}
			class="flex flex-wrap items-center justify-center gap-4 px-6 pb-2 text-start"
		>
			{#each requirements as requirement}
				<div
					class={`animate-grow shadow-custom relative flex flex-grow items-center gap-2 overflow-hidden rounded-lg bg-white p-2 shadow-${accent1} md:flex-grow-0`}
				>
					<div class=" text-start text-xs text-black">{@html requirement}</div>
				</div>
			{/each}
		</div>

		<Button
			textColor="text-white"
			shadow
			css="my-4"
			onclick={() => {
				activeIndex = 0;
				ref.scrollTo({
					left: -1000,

					behavior: "smooth"
				});
			}}
			color="text-{accent1}"
		>
			<ArrowBackwardIos slot="icon-start" class="mr-1.5 size-5  fill-current" />
			<span> {workConditionsTitle} </span>
		</Button>
	</div>
</div>

<div class="flex w-screen justify-center md:max-w-screen-md">
	<button
		on:click={() => {
			activeIndex = 0;
			ref.scrollTo({
				left: -1000,

				behavior: "smooth"
			});
		}}
		class=" p-1"
	>
		<MobileStep active={activeIndex === 1} />
	</button>
	<button
		on:click={() => {
			activeIndex = 1;
			ref.scrollTo({
				left: 1000,

				behavior: "smooth"
			});
		}}
		class="p-1"
	>
		<MobileStep active={activeIndex === 0} />
	</button>
</div>
